import { SamdInstanceFactory } from '@samd/instance_factory';
import { LdtInstanceFactory } from '@ldt/instance_factory';
import { InstanceFactory } from 'src/distribution_platforms/features/utils/base_instance_factory';
import { DistributionPlatform, RepoBackend } from 'src/types/env';

/**
 * Factory function to create an instance factory for a given platform and repository backend.
 */
export function createInstanceFactory(
  platform: DistributionPlatform,
  repoBackend: RepoBackend,
): InstanceFactory {
  if (platform === DistributionPlatform.Ldt) {
    return new LdtInstanceFactory(repoBackend);
  } else if (platform === DistributionPlatform.Samd) {
    return new SamdInstanceFactory(repoBackend);
  }

  throw new Error(`Invalid platform ${platform}`);
}
